import { lazy } from 'react';

import { Route } from 'react-router-dom';

import AppRoute from '../utility/AppRoute';

import ProtectedRoute from '../shared/ProtectedRoute/ProtectedRoute';

import { Roles } from './roles';



const PayrollRuns = lazy(() => import('../modules/Admin/components/Finance/PayrollRuns'));

const SalaryStructures = lazy(() => import('../modules/Admin/components/Finance/SalaryStructures'));

const FinanceExpenses = lazy(() => import('../modules/Admin/components/Finance/FinanceExpenses'));

const FinanceInvoices = lazy(() => import('../modules/Admin/components/Finance/FinanceInvoices'));

const FinancePayments = lazy(() => import('../modules/Admin/components/Finance/FinancePayments'));

const FinanceLedger = lazy(() => import('../modules/Admin/components/Finance/FinanceLedger'));

const FinanceCommissions = lazy(() => import('../modules/Admin/components/Finance/FinanceCommissions'));

const FinanceTaxRules = lazy(() => import('../modules/Admin/components/Finance/FinanceTaxRules'));
const FinanceReports = lazy(() => import('../modules/Admin/components/Finance/FinanceReports'));



const adminStaff = [Roles.SuperAdmin, Roles.Admin, Roles.Manager];



export const financeRoutes = (

  <>

    <Route path="/finance/payroll" element={<ProtectedRoute allowedRoles={adminStaff}><AppRoute><PayrollRuns /></AppRoute></ProtectedRoute>} />

    <Route path="/finance/salary-structures" element={<ProtectedRoute allowedRoles={adminStaff}><AppRoute><SalaryStructures /></AppRoute></ProtectedRoute>} />

    <Route path="/finance/expenses" element={<ProtectedRoute allowedRoles={adminStaff}><AppRoute><FinanceExpenses /></AppRoute></ProtectedRoute>} />

    <Route path="/finance/invoices" element={<ProtectedRoute allowedRoles={adminStaff}><AppRoute><FinanceInvoices /></AppRoute></ProtectedRoute>} />

    <Route path="/finance/payments" element={<ProtectedRoute allowedRoles={adminStaff}><AppRoute><FinancePayments /></AppRoute></ProtectedRoute>} />

    <Route path="/finance/ledger" element={<ProtectedRoute allowedRoles={adminStaff}><AppRoute><FinanceLedger /></AppRoute></ProtectedRoute>} />

    <Route path="/finance/commissions" element={<ProtectedRoute allowedRoles={adminStaff}><AppRoute><FinanceCommissions /></AppRoute></ProtectedRoute>} />

    <Route path="/finance/tax" element={<ProtectedRoute allowedRoles={adminStaff}><AppRoute><FinanceTaxRules /></AppRoute></ProtectedRoute>} />
    <Route path="/finance/reports" element={<ProtectedRoute allowedRoles={adminStaff}><AppRoute><FinanceReports /></AppRoute></ProtectedRoute>} />

  </>

);

